import { createApi } from '@reduxjs/toolkit/query/react'

import envConfig from '~/configs/env'

import anonymizingFetchBaseQuery from '../anonymizingBaseQuery'
import { prepareAuthHeaderWithoutOrg } from '../headers'

// Chargers responses are scoped to the signed-in principal: the site and charger caches hold the
// principal's whole hierarchy and narrow it to the cloaked organization on the client, so a
// request never names the cloaked organization.
const baseQuery = anonymizingFetchBaseQuery({
  baseUrl: envConfig.serviceUrls.chargers,
  prepareHeaders: prepareAuthHeaderWithoutOrg
})

// eslint-disable-next-line import/prefer-default-export
export const api = createApi({
  reducerPath: 'chargersApi',
  baseQuery,
  endpoints: () => ({})
})
